<template>
  <footer class="footer">
    <section class="footer__cont">
      <div class="content">
        <Logo
          class="content__logo-img-w"
        />
        <FooterList :title="_T('@Products')" :list="categories">
          <MyLink class="content__catalog-link" name="catalog">
            {{ _T("@Go to catalog") }}
          </MyLink>
        </FooterList>
        <FooterList :title="_T('@Information')" :list="infoList" />
        <FooterContacts />
        <div class="content__copyrights">
          <Logo
            class="content__logo-img-w"
            @mouseenter="hoverLogo = true"
            @mouseleave="hoverLogo = false"
          />
          <div class="content__copyrights-unit">
            <p class="content__caption">
              &#169; {{ _T("@All rights reserved") }}
            </p>
          </div>
          <div class="content__copyrights-unit">
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/google-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div> 
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/apple-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/privat-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/footerMasterCardIcon.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/footerVisaIcon.svg"
                alt="Visa"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="subscription__block">
        <div class="subscription__block-mailing">
          <div class="subscription__block-mailing-info" >
            <div class="subscription__title-wrp" @click="dropDownProd">
              <h4 class="subscription__block-title">{{ _T("@Newsletter") }}</h4>

              <div class="subscription__itle-mob-arrow">
                <img
                  class="subscription__title-mob-arrow-img"
                  src="@/assets/icons/nav-arrow-down.svg"
                  alt=""
                  :class="{ active: isActive }"
                />
              </div>
            </div>

            <p class="subscription__block-text">{{ _T("@Subscribe to newsletter") }}</p>
          </div>
          <div 
            class="subscription__form-wrp"
            :class="{ active: isActive }"
            :style="{ '--list-height': listHeight + 'px' }"
          >
          <div class="subscription__form-content" ref="subscribeContent">
            <form class="subscription__block-mailing-form">
              <input
                v-model="emailValue"
                class="subscription__block-mailing-input"
                type="email"
                placeholder="E-mail"
              />
              <button
                class="subscription__block-mailing-btn"
                @click.prevent="subscribe"
              >
                {{ _T("@Subscribe") }}
              </button>
            </form>
            <p class="subscription__block-text mobile">{{ _T("@Subscribe to newsletter") }}</p>
          </div>

          </div>
        </div>
        <div class="subscription__block-social">
          <div class="subscription__block-social-w">
            <h4 class="subscription__block-title">
              {{ _T("@Join footer") }}
            </h4>
            <ul class="subscription__block-social-list">
              <li class="subscription__block-social-list-item">
                <a
                  :href="socials.facebook"
                  class="subscription__block-social-list-item-link"
                  target="_blank"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17 2H14C12.6739 2 11.4021 2.52678 10.4645 3.46447C9.52678 4.40215 9 5.67392 9 7V10H6V14H9V22H13V14H16L17 10H13V7C13 6.73478 13.1054 6.48043 13.2929 6.29289C13.4804 6.10536 13.7348 6 14 6H17V2Z"
                      stroke="#1F1F1F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </li>
              <li class="subscription__block-social-list-item">
                <a
                  :href="socials.instagram"
                  class="subscription__block-social-list-item-link"
                  target="_blank"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                      stroke="#1F1F1F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16Z"
                      stroke="#1F1F1F"
                      stroke-width="1.5"
                    />
                    <path
                      d="M17.5 6.51L17.51 6.49889"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
          <div class="content__copyrights-unit">
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/google-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/apple-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/privat-pay-logo.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/footerMasterCardIcon.svg"
                alt="MasterCard"
                loading="lazy"
              />
            </div>
            <div class="content__copyrights-img-w">
              <img
                class="content__copyrights-img"
                src="@/assets/icons/footerVisaIcon.svg"
                alt="Visa"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </footer>
</template>

<script setup>
import useVuelidate from "@vuelidate/core";
import FooterList from "./FooterList.vue";
import { useCategoriesStore } from "~~/store/categoriesStore";
import { emailValidate, requiredValidate } from "~/utils/validators";
import socials from "~/config/social.config";
import Logo from "~~/modules/header/components/UI/Logo.vue";
import { useAPI } from "~/uses/useMyFetch";
import FooterContacts from "~/modules/footer/components/FooterContacts.vue";

const categoriesStore = useCategoriesStore();
const { getTopLevelCategories: categories } = storeToRefs(categoriesStore);

const infoList = [
  { id: 2, title: "@Contacts", routeName: "contacts" },
  { id: 3, title: "@Blog", routeName: "blog_main" },
  { id: 4, title: "@Delivery and payment", routeName: "delivery" },
  { id: 6, title: "@Privacy Policy", routeName: "privacy-policy" },
  { id: 7, title: "@Public offer agreement", routeName: "public-offer" },
  { id: 8, title: "@Household appliance power calculator", routeName: "powerCalculator" },
];

const hoverLogo = ref(false);
const emailValue = ref("");
const isActive = ref(false);
const listHeight = ref(0);

const subscribeContent = ref(null);
 
const rules = computed(() => ({
  required: requiredValidate(),
  email: emailValidate(),
}));

const v = useVuelidate(rules, emailValue);

async function subscribe() {
  const result = await v.value.$validate();

  if (result) {
    useAPI("/marketing/event", {
      method: "POST",
      body: {
        event: "subscription",
        email: emailValue.value,
        isConfirmed: false,
      },
    }).then(() => {
      emailValue.value = "";
    });
  }
}

const dropDownProd = () => {
  if (window.innerWidth <= 680) {
    if (listHeight.value === 0) {
      listHeight.value = subscribeContent.value.scrollHeight;
    } else {
      listHeight.value = 0;
    }

    isActive.value = !isActive.value;
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;

  @include flex-container(column, stretch, center);

  background-color: var(--color-sky-light);

  @extend %padding-wrp;

  &__cont {
    @extend %width-main;

    @include flex-container(column, stretch, center);
    gap: 48px;

    padding: 64px 0 40px;

    @include mobile {
      gap: 24px;

      padding: 48px 0;
    }
  }
}

.content {
  width: 100%;

  @include flex-container;
  gap: 24px 16px;

  & > .content__logo-img-w {
    display: none;

    @include mobile {
      display: block;
      margin-bottom: 16px;
    }
  }

  @include bigMobile {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  @include mobile {
    flex-direction: column;
  }

  &__catalog-link {
    width: 100%;
    max-width: 200px;

    @include font(18, 26);

    color: var(--color-primary-light);

    transition: color 0.2s ease;

    &:hover {
      //color: var(--color-primary-light);
    }

    @include mobile {
      display: none;
    }
  }

  &__title {
    position: relative;
    @include font(20, 30, 600);
    text-transform: uppercase;
    color: var(--color-primary-light);
  }

  &__block-list-link {
    width: 100%;
    max-width: 200px;

    @include font;
    letter-spacing: 0.02em;
    color: white;

    transition: color 0.2s ease-in-out;

    @include mobile {
      max-width: none;
    }

    &:hover {
      color: var(--color-primary-light);
    }
  }

  &__caption {
    @include font(12, 16);
    letter-spacing: 0.02em;
    color: var(--color-sky-darker); 
  }

  &__copyrights-img-w {
    border: 1px solid var(--color-sky-darkest);
    border-radius: 8px;
    padding: 4px 8px;
  }

  &__copyrights {
    width: 100%;
    max-width: 260px;

    @include flex-container(column, stretch, center);
    gap: 16px;

    @include mobile {
      display: none;
    }
  }

  &__logo-img-w {
    font-size: 0;

    @include mobile {
      display: none;
    }
  }

  &__copyrights-unit {
    @include flex-container(row, center, center);
    flex-wrap: wrap;
    gap: 8px;

    & .content__caption {
      width: 100%;
      max-width: 120px;
      text-align: center;
    }

    & + & {
      @include flex-container(row, center, center);
      gap: 16px;
    }
  }

  &__copyrights-caption {
    max-width: 120px;
    width: 100%;

    @include font(12, 16);
    letter-spacing: 0.02em;
    text-align: center;
    color: var(--color-sky-darker);
  }
}

.subscription {
  &__block {
    width: 100%;

    @include flex-container(row, space-between, center);
    gap: 16px;

    border-radius: 16px;
    background-color: var(--color-primary-yellow);

    padding: 16px 32px;

    @include mobile {
      @include flex-container(column, center, flex-start);

      background: none;

      padding: 0;
    }
  }

  &__block-mailing {
    width: 100%;

    @include flex-container(row, flex-start, center);
    gap: 32px;

    @include bigMobile {
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  &__block-mailing-info {
    width: 100%;
    max-width: 355px;

    @include flex-container(column, stretch);
    gap: 16px;

    @include mobile {
      max-width: none;
      gap: 8px;
    }

    & .subscription__block-title {
      @include mobile {
        color: var(--color-primary-light);
      }
    }
  }

  &__title-wrp {
    @include flex-container(row, space-between, center);

    @include mobile {
      border-bottom: 1px solid var(--color-primary-light);

      padding-bottom: 16px;
    }
  }

  &__block-title {
    @include font(20, 30, 600);
    text-transform: uppercase;
    color: var(--color-grey-90);
  }

  &__block-text {
    @include font(12, 16);
    color: var(--color-grey-90);

    @include mobile {
      display: none;

      color: var(--color-sky-darker);
    }

    &.mobile {
      display: none;

      @include mobile {
        display: inline-block;
      }
    }
  }

  &__form-wrp {
    max-width: 484px;
    width: 100%;

    --list-height: 0;

    transition: height 0.5s ease;

    &.active {
      @include mobile {
        height: var(--list-height);
      }
    }

    @include mobile {
      height: var(--list-height);

      overflow: hidden;
    }
  }

  &__form-content {
    @include flex-container(column, center);

    gap: 16px;
  }

  &__block-mailing-form {
    width: 100%;

    position: relative;

    @include flex-container(row, center, center);
  }

  &__block-mailing-input {
    width: 100%;
    height: 40px;

    border-radius: 30px;

    background-color: white;

    padding: 12px 184px 12px 16px;

    &::placeholder {
      @include font(12, 16);
      letter-spacing: 0.02em;
      color: var(--color-primary-yellow);

      @include mobile {
        color: var(--color-sky-darker);
      }
    }
  }

  &__block-mailing-btn {
    width: max-content;

    position: absolute;
    top: 0;
    right: 0;

    @include flex-container(row, center, center);

    @include font(18, 24);
    letter-spacing: 0.02em;
    color: white;

    border-radius: 30px;
    background-color: var(--color-primary-light);

    padding: 8px 32px;

    transition: color 0.2s ease-in-out;
  }

  &__itle-mob-arrow {
    display: none;

    @include mobile {
      display: block;
    }
  }

  &__title-mob-arrow-img {
    transition: transform 0.5s ease;

    &.active {
      transform: rotate(180deg);
    }
  }

  &__block-social {
    @include mobile {
      width: 100%;
      @include flex-container(column, space-between, flex-start);
      gap: 16px;
    }

    & .content__copyrights-unit {
      display: none;

      @include mobile {
        max-width: 240px;
        @include flex-container(row, flex-start, center);
      }
    }
  }

  &__block-social-w {
    @include flex-container(column, stretch, center);
    gap: 16px;

    @include mobile {
      align-items: flex-start; 
    }
  }

  &__block-social-list {
    @include flex-container(row, center, center);
    gap: 24px;
  }

  &__block-social-list-item-link {
    font-size: 0;
    display: inline-block;

    & svg {
      transition: transform 0.2s ease-in-out;
    }

    &:hover svg {
      transform: scale(1.1);
    }
  }
}
</style>